module.exports = __webpack_public_path__ + "static/media/TUNE_4353.c22cb612.jpg";